/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import React from "react";
import { Modal } from "react-bootstrap";
import { TfiClose } from 'react-icons/tfi'

interface LogMediaPowderModalProps {
  show: boolean;
  onClose: () => void;
  onSuccess: () => void;
  title?: string;
  FormComponent: React.ComponentType<any>;
  formProps?: any;
}

const LogMediaPowderModal: React.FC<LogMediaPowderModalProps> = ({
  show,
  onClose,
  onSuccess,
  title,
  FormComponent,
  formProps,
    
}) => {
  return (
    <Modal
      show={show}
      className="top-right-modal top-right-modal-media-prep"
      centered={false}
    >
      <div>
        {/* HEADER */}
        <div className="modalHead">
          <p className="modalHeadText ms-3 pt-3 p-2">
            {title}
          </p>
          <div onClick={onClose} className="p-2 mx-3 my-2">
            <TfiClose fill="#FFFFFF" />
          </div>
        </div>

        {/* BODY */}
        <div style={{ maxHeight: "90vh", overflowY: "auto" }}>
          <FormComponent
            onCancel={onClose}
            onSave={onSuccess}
            {...formProps}
          />
        </div>
      </div>
    </Modal>
  );
};

export default LogMediaPowderModal;